import React from 'react';
import { routes } from 'utils/routes';
import { useHistory } from 'react-router-dom';
import { CheckoutLayout } from '@customer-frontend/page-templates';
import { Button, Typography } from '@eucalyptusvc/design-system';
import { ReactComponent as Figure } from '../../assets/404.svg';
import { ReactComponent as OliveFlush } from '../../assets/olive-flush.svg';
import { ReactComponent as GreenFlush } from '../../assets/green-flush.svg';
import { FormattedMessage } from 'react-intl';

export default function Error(): React.ReactElement {
  const history = useHistory();
  return (
    <CheckoutLayout>
      <div className="space-y-8 md:space-y-9">
        <div className="flex justify-center items-end space-x-1">
          <OliveFlush role="presentation" />
          <Figure role="presentation" />
          <GreenFlush role="presentation" />
        </div>
        <div className="text-center space-y-1">
          <Typography size="md" element="h1">
            <FormattedMessage
              description="Error header shown when there's an unexpected error"
              defaultMessage="Oops! It seems we've gone a little off track"
            />
          </Typography>
          <Typography size="medium-paragraph">
            <FormattedMessage
              description="paragraph prompting the user to go back to the home page"
              defaultMessage="Don't worry, we know the way back. Head home to explore Juniper now."
            />
          </Typography>
        </div>
        <Button isFullWidth onClick={() => history.push(routes.profile)}>
          <FormattedMessage
            description="Button text prompting the user to go to the home page"
            defaultMessage="Back to home"
          />
        </Button>
      </div>
    </CheckoutLayout>
  );
}
